import React from 'react'
import {
    useDisclosure,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Box,
    Text,
    ModalCloseButton,
} from '@chakra-ui/react'
import { replaceTemplateVariables } from '~utils/replace-template-variables'
import { useClinic } from '~contexts/clinic-context'
import SharedLabel from '~components/shared/form/shared-label'
import SharedStack from '~components/shared/wrappers/shared-stack'

interface EmailPreviewButtonProps {
    html: string
}

export default function EmailPreviewButton({ html }: EmailPreviewButtonProps) {
    const {
        isOpen: isPreviewOpen,
        onOpen: onPreviewOpen,
        onClose: onPreviewClose,
    } = useDisclosure()

    const { clinic } = useClinic()

    // Email html stored from the builder embeds {{primary_color}} /
    // {{accent_color}} (with {{clinic_color}} as the primary alias). Resolve
    // just those to the active clinic's real colors so the preview doesn't
    // render literal tags as invalid CSS color values. Other merge tags are
    // intentionally left intact so the change-log still shows them.
    const previewHtml = replaceTemplateVariables(html, {
        clinic_color: clinic?.settings?.primary_color || '#000000',
        primary_color: clinic?.settings?.primary_color || '#000000',
        accent_color: clinic?.settings?.accent_color || '#000000',
    }).value

    return (
        <React.Fragment>
            <Button colorScheme="brand" size="xs" onClick={onPreviewOpen}>
                View
            </Button>
            <Modal isOpen={isPreviewOpen} onClose={onPreviewClose}>
                <ModalOverlay />
                <ModalContent w="100%" maxW="800px">
                    <ModalCloseButton />
                    <ModalHeader>Email Preview</ModalHeader>
                    <ModalBody justifyContent="center">
                        <SharedLabel mb={1}>Body</SharedLabel>
                        {isPreviewOpen && (
                            <Box
                                dangerouslySetInnerHTML={{
                                    __html: previewHtml,
                                }}
                            />
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={onPreviewClose}>Close</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </React.Fragment>
    )
}
